import { useSubsidiary } from "./hook";
import { MouseEvent, useState, FC, useEffect, useContext } from "react";
import { Button, Card, Col, Grid, Row, Space } from "antd";
import Text from "antd/lib/typography/Text";
import Paragraph from "antd/lib/typography/Paragraph";
import { ModalPhone } from "../../ModalPhone/web";
import "./styles.less";
import { useGoogleAnalytics } from "../../../../GlobalHooks/web/GoogleAnalytics.hook";
import { useRouter } from "next/router";
import { useFacebookPixel } from "../../../../GlobalHooks/web/FacebookPixel.hook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
const { useBreakpoint } = Grid;

interface SubsidiaryProps {
	id: string;
	propertyId: string;
	mode: string;
	name: string;
	address: string;
	officeHours: string;
	maskedPhone: string;
	disabled?: boolean;
	listing?: Listing;
}

export const Subsidiary: FC<SubsidiaryProps> = ({
	id,
	propertyId,
	mode,
	name,
	address,
	officeHours,
	maskedPhone,
	disabled = false,
	listing = null,
}) => {
	const { requestLoading, phone, viewPhone } = useSubsidiary({
		id,
	});

	const { country_code } = useContext(ConfigStateContext);

	const GA = useGoogleAnalytics();
	const FP = useFacebookPixel();
	const [modal, setModal] = useState(false);
	const router = useRouter();
	const screen = useBreakpoint();

	const handleClick = (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();
		if (!phone) {
			viewPhone(propertyId).then(data => {
				if (data) {
					setModal(true);
					sendEvent();
				}
			});
		} else {
			sendEvent();
			setModal(true);
		}
	};

	const sendEvent = () => {
		const action = listing?.operation_type?.name ? listing.operation_type.name : router.asPath;
		const categoryName: string = "Consultas Tel";

		GA.Event({
			category: categoryName,
			action: (screen.lg ? "Desktop" : "Mobile") + " " + action,
			label: screen.lg ? "Consulta Tel Desktop" : "Consulta Tel Mobile",
		});

		FP.StandardEvent(categoryName);
	};

	return (
		<Card key={id} size={"small"} className="subsidiary">
			<Row gutter={16} align={"middle"}>
				<Col flex={1} className="left">
					<Text strong className="title">
						{name}
					</Text>
					<Paragraph
						className="paragraph"
						ellipsis={country_code === "ce3" ? false : { rows: 1, expandable: false, symbol: "Más" }}>
						{address}
					</Paragraph>
					<Text type={"secondary"} className={"hours"}>
						{officeHours}
					</Text>
				</Col>
				<Col>
					{country_code !== "BR" && (
						<Space size={4}>
							<Text className="masked">{maskedPhone}</Text>
							<Button
								loading={requestLoading}
								onClick={handleClick}
								className="secondary"
								disabled={disabled}>
								{"Ver teléfono"}
							</Button>
						</Space>
					)}
				</Col>
			</Row>

			<ModalPhone
				mode={mode}
				phone={phone}
				owner_name={name}
				property_id={propertyId}
				loading={requestLoading}
				visible={modal}
				onCancel={() => setModal(false)}
			/>
		</Card>
	);
};
